import { render } from "./EnLargeImg.vue?vue&type=template&id=4c920187&scoped=true"
import script from "./EnLargeImg.vue?vue&type=script&lang=js"
export * from "./EnLargeImg.vue?vue&type=script&lang=js"

import "./EnLargeImg.vue?vue&type=style&index=0&id=4c920187&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c920187"]])

export default __exports__